exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".error[data-v-c4f3feb8]{text-align:left!important;color:#fd8282;font-size:12px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Users/PinModal.vue"],"names":[],"mappings":"AACA,wBACE,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC7B","file":"PinModal.vue","sourcesContent":["\n.error[data-v-c4f3feb8] {\n  text-align: left !important;\n  color: #FD8282;\n  font-size: 12px;\n  font-weight: bold;\n  font-family: 'Open Sans', sans-serif !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c4f3feb8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Users/PinModal.vue
// module id = 1794
// module chunks = 10 17